import {
  accountDetailsTypeDescription,
  BankAccountDetails
} from './bankDetails.types'
import { Currency } from '@sequencehq/api'
import { DashboardApi20240730 } from '@sequencehq/api/dashboard/v20240730'
import { toCurrencyName } from '@sequencehq/utils'

type BankDetails = DashboardApi20240730.Merchants.Merchant['bankAccountDetails']

export const getBankAccountsMap = (bankDetails?: BankDetails | null) => {
  return new Map(
    bankDetails?.map(({ key, value }) => [`${key}_${value.type}`, value])
  )
}

export const validateCurrency = (currency?: string) => {
  const currencyName = toCurrencyName((currency as Currency) ?? '')
  if (!currency || !currencyName) return null
  return {
    key: currency,
    name: currencyName
  }
}

export const validateAccountType = (accountType?: string) => {
  const accountTypeName =
    accountDetailsTypeDescription[
      (accountType as BankAccountDetails['type']) ?? ''
    ]
  if (!accountType || !accountTypeName) return null
  return {
    key: accountType,
    name: accountTypeName
  }
}
